<template>
  <div>
    <div class="title-banner">
      <h4>{{ title }}</h4>
    </div>

    <v-form ref="form" @submit.prevent="create">
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="12">
          <v-text-field v-model="resource.name" color="#41916b" :rules="formRules" label="Nome" required></v-text-field>
        </v-col>
      </v-row>
      <v-card-actions class="d-flex justify-end">
        <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
          <span>{{$t('buttons.cancel')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
          <span>{{$t('buttons.clean_up')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
          <span class="textBtn">{{ textBtn }}</span>
          <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template> 
<script>
import { mapActions } from "vuex";
import { saveDiagnostic } from "@/service/basic-registrations/DeathCauseService";
import Formatters from "@/utils/Formatters";
export default {
  name: "CausaMorteForm",
  data() {
    return {
      loading: false,
      formRules: [(v) => !!v || "Campo obrigatório"],
    };
  },

  computed: {
    title() {
      return 'Causa de Morte Neurológica';
    },

    textBtn() {
      return this.resource.id ? "ATUALIZAR" : "CADASTRAR";
    },
  },
  
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    create() {
      this.loading = true;

      if(this.$refs.form.validate()) {
        const isEdit = !!this.resource.id;
        const dados = {
          name: this.resource.name.toUpperCase()
        };

        saveDiagnostic(isEdit ? this.resource.id : null, dados).then((response) => {
          this.loading = false; 
            this.changeSnackBarData({ 
              status: true,
              type: "success",
              titleMessage:  response.data.message || "Cadastro realizado com sucesso.",
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });
          setTimeout(() => {
            this.closeSnackBar();
            this.closeDialog();
          }, 3000);
        }).catch((err) => { 
          this.loading = false; 
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: Formatters.formatErrorMessage(err),
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 3000);
        });
      }
    },

    closeDialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("closeDialog");
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
      });
    },
  },
};
</script>

<style scoped> 
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.card {
  padding: 35px;
}

.title-banner { 
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);  
  border-radius: 8px; 
  margin-bottom: 20px; 
  display: flex;
  align-items: center;
}

.title-banner>h4 {
  color: #ffffff;
  padding: 10px;
} 
</style>
